import React from 'react';

import {LocalizedHtml, useI18n} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';

import {AT_RISK_STEP_ID, STEP_PROGRESS} from '../constants';
import {AT_RISK_HELP_CTA} from '../events';
import {StepLayout} from '../step-layout.react-component';
import styles from './response-step.module.less';

import type {StepRendererProps} from '../types';

export function OverwhelmedStep({dispatch, onClose, onTrackEventClick}: StepRendererProps) {
    const {gettext} = useI18n();

    const tips = [
        <LocalizedHtml
            key={0}
            html={gettext(
                'Use the <strong class="bold">Learning Reminder</strong> to set aside time on your calendar dedicated to learning. Set a schedule that aligns with your goals. Even 30-minutes a week will make you feel like you are making progress and investing in yourself.',
            )}
            interpolate={{bold: <strong className="ud-text-bold" />}}
        />,
        <LocalizedHtml
            key={1}
            html={gettext(
                'Try our new <strong class="bold">Skill Assessments</strong> that are designed to guide you. They help you skip sections of courses you already know, while pointing out areas where you have gaps and even the specific lectures within courses that could help you.',
            )}
            interpolate={{bold: <strong className="ud-text-bold" />}}
        />,
    ];

    return (
        <StepLayout
            progressValue={STEP_PROGRESS[AT_RISK_STEP_ID.OVERWHELMED]}
            onClose={onClose}
            footerLeftChildren={
                <Button
                    udStyle="ghost"
                    size="medium"
                    onClick={() =>
                        dispatch({type: 'STEP_ADVANCED', nextStepId: AT_RISK_STEP_ID.INITIAL})
                    }
                >
                    {gettext('Back')}
                </Button>
            }
            footerRightChildren={
                <Button
                    udStyle="primary"
                    size="medium"
                    componentClass="a"
                    href="/skills-assessment/"
                    onClick={() => onTrackEventClick(AT_RISK_HELP_CTA.TRY_SKILL_ASSESSMENTS)}
                >
                    {gettext('Try Skill Assessments')}
                </Button>
            }
        >
            <div className={styles['content']}>
                <h2 className="ud-heading-xl">{gettext("That's a lot to carry")}</h2>
                <ol className={styles['tips']}>
                    {tips.map((tip, i) => (
                        <li key={i} className="ud-text-md">
                            {tip}
                        </li>
                    ))}
                </ol>
            </div>
        </StepLayout>
    );
}
